module.exports = __webpack_public_path__ + "96e996ca081ec34e6a2d0d46b3f3b1c1.png";